import styled from 'styled-components'

import { Colours } from '@lib/theme'
import Logo from '@lib/theme/images/PLogo.png'

const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: flex-start;
`

const Img = styled.img`
  height: 2rem;

  margin-right: 0.5rem;
`

const H = styled.h5`
  margin: 0;

  color: ${Colours.FgShade.Dark};
`

export function InventoryLogo() {
  return (
    <Container>
      <Img src={Logo} alt="Parameta Logo" />

      <H>Inventory Explorer</H>
    </Container>
  )
}
